import { ApprovalGroupRootPageQuery } from 'generated/resources/graphql'

import type { Navigation } from 'modules/core/lib/navigation/context'
import type { NavigationPaths } from 'modules/core/lib/navigation/context'

export const settings = (
  data: ApprovalGroupRootPageQuery,
  navigation: Navigation<NavigationPaths>
) => {
  const currentRoute = window.location.pathname
  const approvalGroup = data?.approvals.approvalGroup

  // ---------- PAGES ------------
  const configurationHref =
    navigation.approvals.approvalGroupsCategoryId.details.configuration.fullPath({
      id: String(approvalGroup?.id),
      category: String(approvalGroup?.category),
    })

  const employeesHref = navigation.approvals.approvalGroupsCategoryId.details.employees.fullPath({
    id: String(approvalGroup?.id),
    category: String(approvalGroup?.category),
  })

  // ---------- END PAGES ------------

  // ---------- SETTINGS ------------
  const configurationEditGroupHref =
    navigation.approvals.approvalGroupsCategoryId.details.configuration.editGroup.fullPath({
      id: String(approvalGroup?.id),
      category: String(approvalGroup?.category),
    })

  const employeesEditGroupHref =
    navigation.approvals.approvalGroupsCategoryId.details.employees.editGroup.fullPath({
      id: String(approvalGroup?.id),
      category: String(approvalGroup?.category),
    })
  // ---------- END SETTINGS ------------

  return {
    href: currentRoute === employeesHref ? employeesEditGroupHref : configurationEditGroupHref,
    configurationHref,
    employeesHref,
  }
}
